module.exports = __webpack_public_path__ + "static/media/5.d7aa2b54.jpeg";